import type { Language, Locale } from "@porsche-customer/slfinrtl-context-types"
import type { PFlagProps } from "@porsche-design-system/components-react"

const LANGUAGE_TO_FLAG_NAME: Record<Language, PFlagProps["name"]> = {
	ar: "sa",
	az: "az",
	bg: "bg",
	bs: "ba",
	cs: "cz",
	da: "dk",
	de: "de",
	el: "gr",
	en: "us",
	es: "es",
	et: "ee",
	fi: "fi",
	fr: "fr",
	he: "il",
	hr: "hr",
	hu: "hu",
	hy: "am",
	it: "it",
	ja: "jp",
	ka: "ge",
	ko: "kr",
	lt: "lt",
	lv: "lv",
	mk: "mk",
	nl: "nl",
	no: "no",
	pl: "pl",
	pt: "pt",
	ro: "ro",
	ru: "ru",
	sk: "sk",
	sl: "si",
	sr: "rs",
	tr: "tr",
	uk: "ua",
	zh: "cn",
}

const getLanguage = (locale: Locale | Language): Language => {
	return locale.slice(0, 2).toLowerCase() as Language
}

export const getLanguageFlagName = (locale: Locale | Language): PFlagProps["name"] => {
	const normalized = locale.toLowerCase()

	// Optional precision overrides
	if (normalized.startsWith("zh-tw")) {
		return "tw"
	}
	if (normalized.startsWith("zh-hk")) {
		return "hk"
	}
	if (normalized.startsWith("en-gb")) {
		return "gb"
	}
	const lang = getLanguage(locale)
	return LANGUAGE_TO_FLAG_NAME[lang] ?? "xx"
}
